const EXPORT_STATUS_LABELS: Record<string, string> = {
  success: "Success",
  failed: "Failed",
  dead_letter: "Dead Letter",
  retrying: "Retrying",
  pending: "Pending",
};

export function humanizeExportStatus(status: string): string {
  return EXPORT_STATUS_LABELS[status] ?? status.replace(/_/g, " ");
}
